import client from "./client";
import config from "../lib/config";


export const clearCache = () => {
    const response = client.post(config.api.url + "/api/cache/clear");
    return response;
}